import { ActionContext } from "vuex";
import {
  Question,
  Questionnaire
} from "../../../../domain/entities/exercise/question";
import { interfaceQuestionRepository } from "../../impl/question/question_repository";
import { Answer } from "../../../../domain/entities/exercise/choice";
import { ListResponse } from "../../../../domain/entities/shop/product/listResponse";

class QuestionState {
  questions: Question[] = [];
  question: Question = new Question();
  allQuestions: Question[] = [];
  numberOfPages = 0;
  questionnaire = new Questionnaire();
  timeCounter = 0;
  duration = 0;
}

const state = new QuestionState();

const mutations = {
  SET_QUESTIONS(state: QuestionState, questions: Question[]): void {
    state.questions = questions;
  },

  SET_QUESTION(state: QuestionState, question: Question): void {
    state.question = question;
  },

  SET_ALL_QUESTIONS(state: QuestionState, questions: Question[]): void {
    state.allQuestions = questions;
  },
  SET_NUMBER_OF_PAGES(state: QuestionState, numberOfPages: number): void {
    state.numberOfPages = numberOfPages;
  },
  SET_QUESTIONNAIRE(state: QuestionState, questionnaire: Questionnaire): void {
    state.questionnaire = questionnaire;
  },
  SET_TIME_COUNTER(state: QuestionState, timeCounter: number): void {
    state.timeCounter = timeCounter;
  },
  SET_TIMER_DURATION(state: QuestionState, duration: number): void {
    state.duration = duration;
  }
};

const actions = {
  async loadQuestions(
    { commit }: ActionContext<QuestionState, QuestionState>,
    payload: {
      questionnaireID: number;
      page?: number;
    }
  ): Promise<void> {
    const response: ListResponse<Question[]> = await interfaceQuestionRepository.list(
      payload.questionnaireID,
      payload.page
    );
    commit("SET_QUESTIONS", response.items);
    commit("SET_NUMBER_OF_PAGES", response.page);
    commit("SET_QUESTION", response.items[0]);
  },
  async loadAllQuestions(
    { commit }: ActionContext<QuestionState, QuestionState>,

    questionnaireID: number
  ): Promise<void> {
    const response: ListResponse<Question[]> = await interfaceQuestionRepository.list(
      questionnaireID
    );
    commit("SET_ALL_QUESTIONS", response.items);
  },

  async submitQuestion(
    { commit }: ActionContext<QuestionState, QuestionState>,
    payload: {
      questionnaireID: number;
      questionID: number;
      alternativeID: number;
    }
  ): Promise<Answer> {
    return await interfaceQuestionRepository.submit(
      payload.questionnaireID,
      payload.questionID,
      payload.alternativeID
    );
  },

  async getQuestionnaire(
    { commit }: ActionContext<QuestionState, QuestionState>,
    questionnaireID: number
  ): Promise<void> {
    const questionnaire = await interfaceQuestionRepository.getQuestionnaire(
      questionnaireID
    );
    commit("SET_QUESTIONNAIRE", questionnaire);
  },

  async finishQuestionnaire(
    { commit }: ActionContext<QuestionState, QuestionState>,
    questionnaireID: number
  ): Promise<void> {
    return await interfaceQuestionRepository.finishQuestionnaire(
      questionnaireID
    );
  },

  async setTimeCounter(
    { commit }: ActionContext<QuestionState, QuestionState>,
    timeCounter: number
  ): Promise<void> {
    commit("SET_TIME_COUNTER", timeCounter);
  },

  async setTimerDuration(
    { commit }: ActionContext<QuestionState, QuestionState>,
    duration: number
  ): Promise<void> {
    commit("SET_TIMER_DURATION", duration);
  }
};

const getters = {
  questions: (state: QuestionState): Question[] => state.questions,
  numberOfPages: (state: QuestionState): number => state.numberOfPages,
  questionnaire: (state: QuestionState): Questionnaire => state.questionnaire,
  allQuestions: (state: QuestionState): Question[] => state.allQuestions,
  timeCounter: (state: QuestionState): number => state.timeCounter,
  duration: (state: QuestionState): number => state.duration,
  question: (state: QuestionState): Question => state.question
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
